import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[cartaoMask]',
  standalone: false
})
export class CartaoMaskDirective {
  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const input = event.target;
    let value = input.value.replace(/\D/g, '').substring(0, 16);

    value = value.replace(/(.{4})/g, '$1 ').trim();
    input.value = value;
  }
}